import React from "react";
import styles from "./index.module.scss";
import { AssistantOutlined } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useCampaign } from "../../context/campaign";

function AiInsightDiv({ state, onClick }) {
  // AI Coaching pilot region gate: hide the icon outright outside the pilot
  // allowlist. Centralized here (rather than a wrapper at each call site) so
  // every consumer is covered uniformly, including any added later. This is
  // deliberately isAiCoachingEnabled, not the coach's own manual toggle - a
  // manual "disable AI" should still leave the icon visible and only
  // suppress the popover. See alt-ai-coaching-pilot.md.
  const { isAiCoachingEnabled } = useCampaign();
  if (!isAiCoachingEnabled) return null;

  return <div className={styles.container}>{AiStateText(state, onClick)}</div>;
}

function AiInsightfulLogo() {
  return (
    <svg
      className={styles.icon}
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" />
    </svg>
  );
}

function AiAssistantLogo() {
  return (
    <AssistantOutlined
      style={{ color: "#0A859A", width: "20px", height: "20px" }}
    />
  );
}

function AiAssistant(onClick) {
  const { t } = useTranslation();

  return (
    <div onClick={onClick} className={styles.assistantContainer}>
      {AiAssistantLogo()}
      <span className={styles.aitext}>{t("aiInsight.assist")}</span>
    </div>
  );
}

function AiInsightful() {
  const { t } = useTranslation();

  return (
    <div>
      {AiInsightfulLogo()}
      <span className={styles.text}>{t("aiInsight.insight")}</span>
    </div>
  );
}

function AiStateText(state, onClick) {
  if (state === "compliment") {
    return AiInsightful();
  } else {
    return AiAssistant(onClick);
  }
}

export default AiInsightDiv;
